import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../context/LocalizationContext';
import { ThemedSpinner } from './ThemedSpinner';

export const LocaleReadyGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLocaleReady } = useLocalization();
  const { t } = useTranslation('common');

  if (isLocaleReady) {
    return <>{children}</>;
  }

  return (
    <main className="App-main">
      <ThemedSpinner size="lg" ariaLabel={t('status.loading')} />
    </main>
  );
};